import React, { useEffect, useState } from "react";
import CommonTable from "../../../components/tables/CommonTable";
import { Card } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import UsersSearchTable from "./UsersSearchTable";

const TopMonthlyUsers = ({
  currentMonthCode,
  monthlyHistories,
  mode,
  setLoading,
}) => {
  const [topMonthlyUsers, setTopMonthlyUsers] = useState([]);

  useEffect(() => {
    const topMonthlyUsers = [];

    monthlyHistories &&
      monthlyHistories.forEach((record) => {
        const { user_id, user_name, month_code, total_session_seconds } =
          record;

        if (month_code === currentMonthCode) {
          topMonthlyUsers.push({
            userId: user_id,
            userName: user_name,
            usageMinutes: Math.ceil(total_session_seconds / 60.0),
          });
        }
      });
    setTopMonthlyUsers(
      topMonthlyUsers.sort((a, b) => a.usageMinutes > b.usageMinutes)
    );
  }, [currentMonthCode, monthlyHistories]);

  const columns = [
    {
      Header: "Name",
      accessor: "userName",
      Cell: ({ row, cell }) => (
        <React.Fragment>
          #{row.index + 1}&nbsp;&nbsp;
          <NavLink
            to={{
              pathname: "/users/edit",
              search: `?id=${cell.row.original.userId}`,
            }}
          >
            {cell.value}
          </NavLink>
        </React.Fragment>
      ),
    },
    {
      Header: "Minutes",
      accessor: "usageMinutes",
    },
  ];

  return (
    <React.Fragment>
      <Card className="p-0">
        {mode === "page" ? (
          <UsersSearchTable
            setLoading={setLoading}
            defaultSortBy={[
              { id: "current_month.total_session_seconds", desc: true },
            ]}
          />
        ) : (
          <CommonTable
            columns={columns}
            data={topMonthlyUsers}
            singlePage={mode !== "page"}
            type={mode === "page" ? "" : "dashboard"}
            sort={[{ id: "usageMinutes", desc: true }]}
            emptyMessage="No data available"
          />
        )}
      </Card>
    </React.Fragment>
  );
};

export default TopMonthlyUsers;
